// Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 24597, offsets 1158:138599. Structure and names inferred from code, not screenshots.
import * as DestinationsModule from "../config/destinations.js";
let heroActions = [
  {
    key: "chat",
    labelKey: "home.hero.chat",
    href: "https://www.15token.win/dashboard",
    variant: "primary",
    legacyEvent: "HOME_STUDIO_ENTRY_CLICK",
    trackEvent: "home_hero_click",
    bannerTrackEvent: "home_bigbanner_studio_click",
    trackParams: {
      title: "studio",
    },
  },
  {
    key: "api",
    labelKey: "home.hero.api",
    href: "https://www.15token.win/keys",
    variant: "outline",
    legacyEvent: "HOME_API_ENTRY_CLICK",
    trackEvent: "home_hero_click",
    bannerTrackEvent: "home_bigbanner_apiaccess_click",
    trackParams: {
      title: "api",
    },
  },
  {
    key: "tokenPlan",
    labelKey: "home.hero.tokenPlan",
    href: "https://catfk.com/shop/15token",
    variant: "outline",
    legacyEvent: "HOME_TOKEN_PLAN_ENTRY_CLICK",
    trackEvent: "home_hero_click",
    bannerTrackEvent: "home_bigbanner_tokenplan_click",
    trackParams: {
      title: "tokenpaln",
    },
  },
];
let heroModelLinks = [
  {
    name: "GPT-6 Astra",
    href: "https://developers.openai.com/api/docs/models/gpt-6-astra",
    trackTitle: "dropdown_gpt6astra",
  },
  {
    name: "Claude Opus 5.5",
    href: "https://www.anthropic.com/claude/opus",
    trackTitle: "dropdown_claudeopus55",
  },
  {
    name: "Kimi K3",
    href: "https://www.kimi.com/ai-models/kimi-k3",
    trackTitle: "dropdown_kimik3",
  },
  {
    name: "DeepSeek-V4.1-Flash",
    href: "https://www.deepseek.com/en/news/deepseek-v4-1-flash",
    trackTitle: "dropdown_deepseekv41flash",
  },
];
export { heroActions, heroModelLinks };
